import {
  setTypeGroup,
  getTypeGroupsSuccess,
} from "features/typeDataSharedSlice";
import { call, put, takeLatest } from "redux-saga/effects";
import { DELETE, GET, PATCH, POST, PUT } from "services/ServiceBase";
import ServiceURL from "services/ServiceURL";
import { ActionType } from "type";
import _ from "lodash";

export function* getTypeGroups(data: ActionType): any {
  const { callback, body, query, skipUpdateReducer } = data.payload;
  const url = `${ServiceURL.typeshared}?${query ?? ""}`;
  try {
    const res = yield call(GET, url, body);
    if (!!res?.code && !!res?.message) {
      callback.failed(res?.message);
    } else {
      if (!skipUpdateReducer)
        yield put(getTypeGroupsSuccess(_.get(res, "data", {})));
      callback.success(_.get(res, "data", {}));
    }
  } catch (error: any) {
    const err = error?.response?.data?.message || error?.message;
    callback.failed(err);
  }
}

export function* getTypeGroup(data: ActionType): any {
  const { callback, body, query, params, skipUpdateReducer } = data.payload;
  const url = `${ServiceURL.typeshared}/${params}?${query ?? ""}`;
  try {
    const res = yield call(GET, url, body);
    if (res.data?.error?.message) {
      callback.failed(res.data?.error?.message);
    } else {
      if (!skipUpdateReducer) yield put(setTypeGroup(_.get(res, "data", {})));
      callback.success(_.get(res, "data", {}));
    }
  } catch (error: any) {
    const err = error?.response?.data?.message || error?.message;
    callback.failed(err);
  }
}
export function* createTypeGroup(data: ActionType): any {
  const { callback, body } = data.payload;
  const url = ServiceURL.typeshared;
  try {
    const res = yield call(POST, url, body);
    if (!!res?.response?.data?.code && !!res?.response?.data?.message) {
      callback.failed(res?.response?.data?.message);
    } else {
      callback.success(_.get(res, "data", {}));
    }
  } catch (error: any) {
    const err = error?.response?.data?.message || error?.message;
    callback.failed(err);
  }
}

export function* updateTypeGroup(data: ActionType): any {
  const { callback, body, params } = data.payload;
  const url = `${ServiceURL.typeshared}/${params}`;
  try {
    const res = yield call(PATCH, url, body);
    if (!!res?.response?.data?.code && !!res?.response?.data?.message) {
      callback.failed(res?.response?.data?.message);
    } else {
      callback.success(_.get(res, "data", {}));
    }
  } catch (error: any) {
    const err = error?.response?.data?.message || error?.message;
    callback.failed(err);
  }
}
export function* deleteTypeGroup(data: ActionType): any {
  const { callback, body, params } = data.payload;
  const url = `${ServiceURL.typeshared}/${params}`;
  try {
    const res = yield call(DELETE, url, body);
    if (res.data?.error?.message) {
      callback.failed(res.data?.error?.message);
    } else {
      callback.success(res);
    }
  } catch (error: any) {
    const err = error?.response?.data?.message || error?.message;
    callback.failed(err);
  }
}
export default function* typeDataSharedSaga() {
  yield takeLatest("typeDataSharedSlice/getTypeGroups", getTypeGroups);
  yield takeLatest("typeDataSharedSlice/getTypeGroup", getTypeGroup);
  yield takeLatest("typeDataSharedSlice/createTypeGroup", createTypeGroup);
  yield takeLatest("typeDataSharedSlice/deleteTypeGroup", deleteTypeGroup);
  yield takeLatest("typeDataSharedSlice/updateTypeGroup", updateTypeGroup);
}
